<template>
  <div class="">
    <div class="tc">
      <ProfilePicture
        :userProfilePicture="proUser.profilePicture"
        isPro
        :size="128"
      />
    </div>

    <h3 class="f2">{{proUser.fullName}}</h3>

    <p class="f3 near-black lh-copy">{{proUser.proProfile.jobTitle}}</p>
    <div class="flex items-center pt1">
      <img src="/img/location-icon.svg" alt="Location">
      <p class="near-black lh-copy f4 mv0 pv0 pl2">{{proUser.livesIn}}</p>
    </div> 

    <div class="pv4">
      <div v-if="!userIsAuthenticated">
        <p class="near-black lh-copy f4"><a :href="loginUrlWithPassback" class="db tc teal dim hover-teal br3 bg-teal-10 pa3 w-100">Sign in to send a message</a></p>
      </div>
      <div v-if="userIsAuthenticated">
        <div class="shadow-1 bg-white br2 pa4">
            <p class="near-black lh-copy f4 fw6">Send a message to {{proUser.fullName}}</p>
            <message-form :currentUserIsAuthenticated="userIsAuthenticated" :message-to="proUserId"></message-form>
        </div>
      </div>
    </div>

    <div class="f4 near-black lh-copy pv4">
      <pro-profile-bio :pro-user="proUser"/>
    </div>
    

    <div v-if="proUser.proProfile" class="pv4">
      <div class="cf ph3 ph0-ns">
        <h4 class="f3 near-black mb4">Tags</h4>
        <div v-for="tag in proUser.proProfile.tags" class="bg-white ba b--light-gray mid-gray dib mh1 mb2 br-pill f4 pv2 ph3">{{tag.id}}</div>
      </div>
    </div>

    <pro-profile-social :pro-user="proUser" />

  </div>
</template>

<script>

import proProfileService from '../../../../api/ProProfileService'
import MessageForm from '../../messaging/components/MessageForm'
import ProfilePicture from '../../../user/profile/components/ProfilePicture'
import ProProfileBio from './ProProfileBio'
import ProProfileSocial from './ProProfileSocial'
import _ from 'lodash'
import { mapState, mapGetters } from 'vuex'

export default {
    name: 'ProProfileDetails',
    components: {MessageForm, ProfilePicture, ProProfileBio, ProProfileSocial},
    props: {
        proUserId: {
            type: String,
            required: true,
        },
    },
    computed: {
        ...mapState(['currentUser', 'env']),
        ...mapGetters(['userHasRolePro']),

        userIsAuthenticated: function(){
            return !_.isNil(this.currentUser.id);
        },
        loginUrlWithPassback: function(){
            return `/login?postAuthRequestPath=/pro/profile/${this.proUserId}`;
        },
    },
    data() {
        return {
            proUser: {
                id: null,
                livesIn: null,
                twitterUsername: null,
                instagramUsername: null,
                profilePicture: null,
                facebookUsername: null,
                fullName: null,
                proProfile: {
                    jobTitle: null,
                    bio: null,
                    tags: [],
                },
            }
        };
    },
    methods: {
    },

    created() {
        proProfileService.getProUserProfile(this.proUserId).then(response => {
            this.proUser = response.data;
        })
    }
}
</script>

<style scoped>



</style>



// WEBPACK FOOTER //
// src/main/frontend/vue/js/modules/pro/profile/components/ProProfileDetails.vue